// client/App.js
import React, { useEffect, useContext } from 'react';
import GlobalProvider from './context/provider';
import AppNavigation from './navigation'; // Use react-router-dom for web navigation
import InstallPrompt from './components/installApp/InstallPrompt';
import FCMHandler from './components/FCMHandler';

import './styles/notification.css';

const App = () => {
  console.log("Prof-iX Web App Loaded");
  return (
    <GlobalProvider>
      <InstallPrompt />
      <FCMHandler />
      <AppNavigation />
    </GlobalProvider>
  );
};

export default App;